import SocketioService from '@/services/socketioService';
import axios from 'axios'
import { getWindowUrl } from '@/helpers.js'
import store from '@/store';
import { Role } from '@/helpers';

// const getDefaultState = () => {
//   return {
// 		status: null,
// 		token: localStorage.getItem('token') || '',
// 		user: localStorage.getItem('user') || null,
// 	}
// }

const state = {
	status: "noauth",
	token: localStorage.getItem('token') || '',
	mama: null,
	papa: null,
	user: null,
}

// const state = getDefaultState();

const getters = {
	isLoggedIn: () => {
		console.log(`[APP]`, state.token);
		console.log(`[APP]`, !!state.token);
		return !!state.token;
	},
	loginStatus: (state) => {
		if (state.status)	return state.status;
		else return null;
	},
	getUser: (state) => {
		if (state) {
			// return state.user;
			// if (localStorage.getItem('user')) return JSON.parse(localStorage.getItem('user'));
			// else return state.user;
			return state.user;
		} else {
			return null;
		}
	},
	isMaster: (state) => {
		if (state && state.user) {
			if (state.user.role === Role.Admin || state.user.role === Role.Master) {
					return true;
			}
		}
		return false;
	},
	getToken: state => {
		return state.token;
	}
}

const mutations = {
  setRequest(state) {
		state.status = 'loading';
	},
	// setSuccess(state, {token, user}) {
	// 	state.status = 'success';
	// 	state.mama = token;
	// 	state.papa = user;
	// 	state.token   = token;
	// 	// state.user    = user;
	// },
	setSuccess(state) {
		state.status = 'success';
	},
	setBusy(state) {
		state.status = 'busy';
	},
	setError(state) {
		state.status = 'error';
	},
	setNewToken(state) {
		state.mama = '';
	},
	setLogout(state) {
		state.status = 'noauth';
		state.token = '';
		state.user = null;
	},
	setToken: (state, token) => {
		state.token = token;
	},
	setReset: (state) => {
		// Object.assign(state, getDefaultState());
		state.status = 'noauth';
	},
	setUser(state, user) {
		state.status = 'success';
		state.user    = user;
	},
};

const actions = {
	async setAuthorizationHeaderFromStorage({ commit }) {
		let promisedEvents = [];
    const storeToken = localStorage.getItem('token');
		const storeUser = JSON.parse(localStorage.getItem('user'));
		console.log("[AUTH] set auth started");
		// console.log(storeToken);
		// console.log(storeUser);
    if (storeToken && storeUser) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${storeToken}`
      // commit('setSuccess', {storeToken, storeUser});
			// commit('setSuccess');
			commit('setBusy');
			console.log(`[INIT] fetch userinfo`);
			promisedEvents.push(store.dispatch("auth/fetchUser"));
			console.log(`[INIT] socketio start sequence`);
			promisedEvents.push(store.dispatch("startSocketIo", null));
			let result;
      try {
        result = await Promise.all(promisedEvents);
        // store.dispatch("setGlobalLoader", { loading: false, init: true, title: '' });
        console.log(`[INIT] initial connection phase done!`);
        return result;
      } catch (error) {
				console.error(`[INIT] Token check failed, starting fresh`, error);

				localStorage.removeItem('token');
				localStorage.removeItem('user');
				delete axios.defaults.headers.common['Authorization'];

				store.dispatch("auth/logout");
      }

			// store.dispatch("auth/fetchUser").then(() => { 
			// 	store.dispatch("startSocketIo", null).then(() => {
			// 		console.log(`[INIT] all done (auth setHeaderStorage)`);
			// 		store.dispatch("setGlobalLoader", { loading: false, init: true, title: '' });
			// 		console.log(`[INIT] initial connection phase done!`);
			// 	});
			// });
    }
  },
	loadNewToken: ({ commit }, tokenData) => {
		commit('setNewToken');
		localStorage.setItem('token', tokenData.token);
		localStorage.setItem('user', JSON.stringify(tokenData.user));
		console.log('NEW TOKEN UPDATE:');
		console.log(tokenData.token);
		console.log(tokenData.user);
		const storeToken = localStorage.getItem('token');
		const storeUser = JSON.parse(localStorage.getItem('user'));
		console.log(`[AUTH-LOGIN] <TOKEN> ${storeToken} | <USER> ${storeUser}`);
		if (storeToken && storeUser) {
			SocketioService.renewSocketToken(storeToken);
			axios.defaults.headers.common['Authorization'] = `Bearer ${storeToken}`;
			console.log(`[TOKEN] renewal complete!`);
			console.log(`[TOKEN] ${storeToken}`);
			store.dispatch("auth/fetchUser");
			// commit('setSuccess', {storeToken, storeUser});
		}
		// console.log(localStorage.getItem('token'));
		// console.log(localStorage.getItem('user'));
	},
	async startSequence() {
		let promisedEvents = [];
		console.log("[AUTH] login process started");
		console.log(`[INIT] fetch userinfo`);
		promisedEvents.push(store.dispatch("auth/fetchUser"));
		console.log(`[INIT] socketio start sequence`);
		promisedEvents.push(store.dispatch("startSocketIo", null));
		let result;
		try {
			result = await Promise.all(promisedEvents);
			console.log(`[INIT] login process finished!`);
			return result;
		} catch (error) {
			console.error(`[INIT] Promise error!`)
		}
  },
	async loginUser({commit}, user) {
		let url = null;
		if (process.env.VUE_APP_LOCALDEV === "true") {
			url = "/login";
		} else {
			url = "https:" + "//" + getWindowUrl().host + "/enatsrv/login";
		}
		console.log(`[AUTH] login url: ${url}`);
		try {
			const response = await axios.post(url, {
				username: user.username,
				password: user.password
			});
			commit('setNewToken');
			console.log(response.data); // ✅ Handle the response
			return response.data; // ✅ Return data if needed
		} catch (error) {
			console.error("Login failed:", error);
			throw error; // ✅ Rethrow the error if needed
		}
	},
	async login({ commit }, axiosUser) {
			const storeToken = localStorage.getItem('token');
			const storeUser = JSON.parse(localStorage.getItem('user'));
			console.log(`[AUTH-LOGIN] <TOKEN> ${storeToken} | <USER> ${storeUser}`);
			if (storeToken && storeUser) {
				axios.defaults.headers.common['Authorization'] = `Bearer ${storeToken}`;
				commit('setSuccess', {storeToken, storeUser});
				// resolve(null);
			} else {
				try {
					// store.dispatch("setGlobalLoader", { loading: true, init: true, title: '' });
					const userData = await store.dispatch("auth/loginUser", axiosUser);
					// const userData = await loginUser(axiosUser);
					console.log("User logged in:", userData);
					const token = userData.newToken;
					const user  = userData.userObj;
					console.log(token);
					console.log(user);
					localStorage.setItem('token', token);
					localStorage.setItem('user', JSON.stringify(user));
					axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
					console.log(`[AUTH] <TOKEN> ${token}`);
					console.log(`[AUTH] <TOKEN_LOCALSTORAGE> ${localStorage.getItem('token')}`);
					commit('setBusy');
					await store.dispatch("auth/startSequence");
					// store.dispatch("setGlobalLoader", { loading: false, init: true, title: '' });
					return user;
				} catch (error) {
					console.log(`[AUTH] ERROR!!!`);
					commit('setError');
					localStorage.removeItem('token');
					localStorage.removeItem('user');
					// reject(error);
				}

				// let url = null;
				// if (process.env.VUE_APP_LOCALDEV === "true") {
				// 	url = "/login";
				// } else {
				// 	url = "https:" + "//" + getWindowUrl().host + "/enatsrv/login";
				// }
				// console.log(`[AUTH] login url: ${url}`);
				// axios.post(url, {
				// 	username: user.username,
				// 	password: user.password
				// })
				// .then(response => {
				// 		const token = response.data.newToken;
				// 		const user  = response.data.userObj;
				// 		console.log(token);
				// 		console.log(user);
				// 		localStorage.setItem('token', token);
				// 		localStorage.setItem('user', JSON.stringify(user));
				// 		axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
						
				// 		console.log(`[AUTH] <TOKEN> ${token}`);
				// 		console.log(`[AUTH] <TOKEN_LOCALSTORAGE> ${localStorage.getItem('token')}`);
				// 		// store.dispatch("startSocketIo", null);
				// 		commit('setBusy');
				// 		store.dispatch("auth/startSequence");

						// store.dispatch("startSocketIo", null).then(() => { 
						// 	console.log(`[INIT] all done (auth login)`);
						// 	store.dispatch("setGlobalLoader", { loading: false, init: true, title: '' });
						// 	console.log(`[INIT] initial connection phase done!`);
						// });
						// commit('setSuccess', {token, user});
						// console.log(response);
						// resolve(response);
				// }).catch(err => { 
				// 		console.log(`[AUTH] ERROR!!!`);
				// 		commit('setError');
				// 		localStorage.removeItem('token');
				// 		localStorage.removeItem('user');
				// 		reject(err);
				// });

				// .then(response => {
				// 		const token = response.data.newToken;
				// 		const user  = response.data.userObj;
				// 		console.log(token);
				// 		console.log(user);
				// 		localStorage.setItem('token', token);
				// 		localStorage.setItem('user', JSON.stringify(user));
				// 		axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
				// 		commit('setSuccess', {token, user});
				// 		console.log(response);
				// 		resolve(response);
				// 		console.log(`[AUTH] <TOKEN> ${token}`);
				// 		store.dispatch("startSocketIo", null);
				// }).catch(err => { 
				// 		commit('setError');
				// 		localStorage.removeItem('token');
				// 		localStorage.removeItem('user');
				// 		reject(err);
				// });
			}
		
		// // let url = helpers.getWindowUrl().protocol + "//" + helpers.getWindowUrl().host + ":" + 3000 + helpers.getWindowUrl().path;
		// const url = "https:" + "//" + getWindowUrl().host + ":" + 3001 + getWindowUrl().path;
		// console.log(url);
		// // let url = "http://192.168.88.247:" + 3000 + getWindowUrl().path;
		// return new Promise((resolve, reject) => {
		// 	commit('setRequest')
		// 	axios.post(url + 'login', {
		// 		username: user.username,
		// 		password: user.password
		// 	})
		// 	.then(response => {
		// 			const token = response.data.token;
		// 			const user  = response.data.user;
		// 			localStorage.setItem('token', token);
		// 			localStorage.setItem('user', JSON.stringify(user));
		// 			axios.defaults.headers.common['Authorization'] = "Bearer" +token;
		// 			commit('setSuccess', {token, user});
		// 			console.log(response);
		// 			resolve(response);
		// 	}).catch(err => { 
		// 			commit('setError');
		// 			localStorage.removeItem('token');
		// 			reject(err);
		// 	});
		// });
	},
	logout: ({ commit }) => {
		return new Promise((resolve) => {
			commit('setLogout');
			localStorage.removeItem('token');
			localStorage.removeItem('user');
			delete axios.defaults.headers.common['Authorization'];
			// SocketioService.disconnect();
			store.dispatch("logout");
			commit('setReset');
			console.log("LOGOUT");
			this.$router.push({ path: "/login", replace: true });
			resolve();
		});
	},
	async fetchUser({ state, commit }) {
		let url = null;
		if (process.env.VUE_APP_LOCALDEV === "true") {
			url = "/userinfo";
		} else {
			url = "https:" + "//" + getWindowUrl().host + "/enatsrv/userinfo";
		}
	
		try {
			const response = await axios.get(url, {
				headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
			});
	
			console.log('[AUTH] <USERINFO>: ', response.data);
			commit('setToken', localStorage.getItem('token'));
			commit('setUser', response.data);
			console.log(`[INIT] <AUTH> loading finished!`);
	
			return state.user;
		} catch (error) {
			console.error('[AUTH] <USERINFO> failed:', error);
			throw error; // Important: so the caller (init block) can detect failure
		}
	},	
};

export default {
  namespaced: true,
  state,
	getters,
  mutations,
  actions,
};